//////////////////////////////////////////////////
/// AREA: ソースインポート
//////////////////////////////////////////////////

// 独自モジュール
import { FadeInEffect } from './modules/animation/_Fade';
import { SlideController } from './modules/animation/_Slide';
import { ClickEventHandler } from './modules/dom/_ClickEvent';
import { ClassListController } from './modules/dom/_ClassProcessor';
import { StyleController } from './modules/dom/_CssProperty';
import { GraphicsLazyController } from './modules/media/_Graphics';

// サイト機能
import { ModalDisplay } from './features/ModalWindow';
import { CollapsePanel } from './features/Collapse';
import { TabSwitcher } from './features/TabSwitch';
// import { SlideDisplay } from './features/SlideShow';

//////////////////////////////////////////////////
/// AREA: グローバル変数
//////////////////////////////////////////////////

const gSiteBody: HTMLElement = document.body;
const gLazyTargets = [
  {
    selector: '.lazy_bg_image',
    options: {}
  },
  {
    selector: '.lazy_iframe',
    options: {
      rootMargin: '480px',
    }
  }
];

const gLazyController: GraphicsLazyController = new GraphicsLazyController(gLazyTargets);

let gScrollFlag: boolean = false;
let gResizeFlag: boolean = false;

//////////////////////////////////////////////////
/// AREA: トップページ
//////////////////////////////////////////////////

/// Part Name: ヒーロービュー
// const frontHeroView = {
//   INIT_OPACITY: 1,
//   MIN_SCALE: 1,
//   MAX_SCALE: 1.24,
//   MAX_POSITION: 960,
//   INTERVAL_OPACITY: 800,
//   INTERVAL_SCALE: 2400,
//   // mVisual: document.getElementById('primaryHeroView')?.querySelector('.visual')?.querySelector('.image') as HTMLElement | null,
//   mVisual: document.getElementById('primaryHeroView')?.querySelector('.visual')?.querySelector('.bg_image') as HTMLElement | null,
//   mWindowHeight: window.innerHeight,
//   StyleController: new StyleController(),

//   scrollAnimation(): void
//   {
//     const elem_style: CSSStyleDeclaration | undefined = this.mVisual?.style;

//     this.applyFadeOut(elem_style);
//     // mVisualがbackground-image: background, img要素: object を指定
//     // this.applyPosition(elem_style, 'background');
//     // スクロール時大きく: increase, 小さく: decrease
//     this.applyScale(elem_style, 'decrease');
//   },

//   applyFadeOut(style: CSSStyleDeclaration | undefined): void
//   {
//     const value: number = this.INIT_OPACITY - window.scrollY / this.INTERVAL_OPACITY;

//     this.StyleController.clampValue(style, 'opacity', `${value}`, 0, this.INIT_OPACITY);
//   },

//   applyPosition(style: CSSStyleDeclaration | undefined, property: string = 'object'): void
//   {
//     const inset_posY: number = window.scrollY;
//     const elem_posY: number = - window.scrollY / 2;

//     this.StyleController.clampValue(style, 'inset-block-start', `${inset_posY}px`, 0, this.MAX_POSITION,);

//     if (property === 'object')
//     {
//       const prop_pos: string = 'object-position';
//       this.StyleController.clampValue(style, prop_pos, `bottom ${elem_posY}px`, - this.MAX_POSITION / 2, 0);
//     }
//     else if (property === 'background')
//     {
//       const prop_pos: string = 'background-position-y';
//       this.StyleController.clampValue(style, prop_pos, `${elem_posY}px`, - this.MAX_POSITION / 2, 0,);
//     }
//   },

//   applyScale(style: CSSStyleDeclaration | undefined, direction: 'increase' | 'decrease'): void
//   {
//     const value: number =
//       direction === 'increase'
//         ? this.MIN_SCALE + window.scrollY / this.INTERVAL_SCALE
//         : this.MAX_SCALE - window.scrollY / this.INTERVAL_SCALE;

//     this.StyleController.clampValue(style, 'scale', `${value}`, this.MIN_SCALE, this.MAX_SCALE);
//   },
// };

//////////////////////////////////////////////////
/// AREA: Webサイト共通
//////////////////////////////////////////////////

/// Part Name: スクロールエフェクト
const gScrollFadeIn = {
  fromLeft: {
    FadeInEffect: new FadeInEffect(gSiteBody.getElementsByClassName('from_left')),
    onAnimation(): void
    {
      // IntersectionObserver を使ってフェードインを登録
      this.FadeInEffect.observe('fadeInFromLeft');
    }
  },
  fromBottom: {
    FadeInEffect: new FadeInEffect(gSiteBody.getElementsByClassName('from_bottom')),
    onAnimation(): void
    {
      this.FadeInEffect.observe('fadeInFromBottom');
    }
  },
  slideDoor: {
    FadeInEffect: new FadeInEffect(gSiteBody.getElementsByClassName('slide_door')),
    onAnimation(): void
    {
      this.FadeInEffect.observe('fadeInSlideDoor');
    }
  }
};

/// Part Name: グローバルナビ
const gHeaderNavi = {
  ClickEventHandler: new ClickEventHandler(),
  mIcon: document.getElementById('gHeaderNaviIcon'),
  mNavi: document.getElementById('gHeaderNavi'),
  mNaviItems: null as HTMLCollectionOf<Element> | null,
  mToggleClassName: 'is_active',

  main(): void
  {
    if (this.clickToToggleDisplay)
    {
      this.clickToToggleDisplay();
    }
    if (this.clickToCloseDisplay)
    {
      this.clickToCloseDisplay();
    }
  },
  clickToToggleDisplay(): void
  {
    if (this.mIcon && this.mNavi)
    {
      this.ClickEventHandler.mTrigger = this.mIcon;
      this.ClickEventHandler.mTarget = this.mNavi;
      this.ClickEventHandler.toggleClassOnTarget(this.mToggleClassName);
    }
  },

  clickToCloseDisplay(): void
  {
    if (this.mNavi)
    {
      this.mNaviItems = this.mNavi.getElementsByClassName('item');
      for (const item of this.mNaviItems)
      {
        item.addEventListener('click', () =>
        {
          if (this.mIcon?.classList.contains(this.mToggleClassName) && this.mNavi?.classList.contains(this.mToggleClassName))
          {
            this.mIcon.classList.remove(this.mToggleClassName);
            this.mNavi.classList.remove(this.mToggleClassName);
          }
        });
      }
    }
  }
};

/// Part Name: サイドナビ
// const gSideNavi = {
//   BREAK_POINT: 1201,
//   mNavi: document.getElementById('gSideNavi'),

//   scrollFixed(): void
//   {
//     if (this.mNavi && window.innerWidth >= this.BREAK_POINT)
//     {
//       const navi_rect: DOMRect = this.mNavi.getBoundingClientRect();
//       const navi_height: number = navi_rect.height;
//       const move_posY: string = 'calc(50% - ' + navi_height / 2 + 'px)';
//       const navi_top: number = window.scrollY + navi_rect.top;

//       if (window.scrollY > navi_top / 2)
//       {
//         this.mNavi.style.position = 'fixed';
//         this.mNavi.style.insetBlockEnd = move_posY;
//       }
//       else
//       {
//         this.mNavi.style.position = 'absolute';
//         this.mNavi.style.removeProperty('inset-block-end');
//       }
//     }
//   }
// };

/// Part Name: バックスクロールボタン
const gBackScrollBtn = {
  ClassListController: new ClassListController(),
  ClickEventHandler: new ClickEventHandler(),
  mButton: document.getElementById('gBackScrollBtn'),
  isDisplayed: false,
  onAnimation(target_height = 200): void
  {
    this.ClassListController.mTarget = this.mButton;
    const should_display: boolean = window.scrollY > target_height;

    if (should_display !== this.isDisplayed)
    {
      this.isDisplayed = should_display;
      if (should_display)
      {
        if (this.mButton) this.mButton.style.visibility = 'visible';
        this.ClassListController.switchClass('fadeOutDisp', 'fadeInDisp');
      }
      else
      {
        this.ClassListController.switchClass('fadeInDisp', 'fadeOutDisp');
      }
    }
  },

  toPageTop(): void
  {
    this.ClickEventHandler.mTrigger = this.mButton;
    this.ClickEventHandler.scrollToPageTop();
  }
};

/// Parts Name: 関連サービスボタン
const shop_button = document.querySelectorAll('.g-btn-related');

for (const button of shop_button)
{
  // button.addEventListener('click', () =>
  // {
  //   window.open(button.dataset.url, '_blank');
  // });
  if (button instanceof HTMLElement)
  {
    let scroll_timer: number | null = null;

    window.addEventListener('scroll', () =>
    {
      button.classList.add('is_hidden');

      if (scroll_timer !== null)
      {
        window.clearTimeout(scroll_timer);
      }

      scroll_timer = window.setTimeout(() =>
      {
        button.classList.remove('is_hidden');
      }, 400);
    });
  }
}

/// Part Name: コピーライト
const gCopyright = {
  SINCE_YEAR: 2025,
  mDispYear: document.getElementById('dispYear'),
  iDate: new Date(),

  getNowYear(): number
  {
    const now_year: number = this.iDate.getFullYear();
    return now_year;
  },

  dispYear(): void
  {
    if (this.mDispYear)
    {
      if (this.SINCE_YEAR === this.getNowYear())
      {
        this.mDispYear.innerHTML += this.SINCE_YEAR;
      }
      else
      {
        this.mDispYear.innerHTML += `${this.SINCE_YEAR} - ${this.getNowYear()}`;
      }
    }
  }
};

//////////////////////////////////////////////////
/// AREA: debugコード
//////////////////////////////////////////////////

// const collapseSection = {
//   mStaffReview: {
//     root: document.getElementById('primaryStaff'),
//     mount(): void
//     {
//       collapseSection.setup(this.root, (panel: CollapsePanel) =>
//       {
//         panel.applyDetails(
//           {
//             slideSelector: '.review-details',
//             triggerSelector: '.m-heading-summary',
//             targetSelector: '.m-content',
//           }
//         );
//       });
//     }
//   },
//   setup(root: HTMLElement | null, bind: (panel: CollapsePanel) => void, duration?: number): void
//   {
//     if (!root) return;

//     const panel = new CollapsePanel(root, duration);
//     bind(panel);
//   }
// };

// collapseSection.mStaffReview.mount();

// const tabSection = {
//   mShopping:
//   {
//     root: document.getElementById('primaryArchiveShopping'),
//     mount(): void
//     {
//       tabSection.setup(this.root, (switcher: TabSwitcher) =>
//       {
//         switcher.applyTabs({
//           tabSelector: '.list-post .item .details',
//           panelSelector: '.tab-panels > .entry',
//           activeClassName: 'is_active',
//           initialIndex: 0,
//           // ① フェード + 高さアニメーション（デフォルト）
//           // heightMode を省略 or:
//           heightMode: 'animate',

//           // ② 高さだけ「パッ」と即切り替え（フェードは残る）
//           // heightMode: 'instant',

//           // ③ 全パネルの「最大高さ」に固定（はみ出しなし・画面も動かない）
//           // heightMode: 'fixed',
//         });
//       });
//     }
//   },
//   mCustomerVoice:
//   {
//     root: document.getElementById('primaryArchiveCustomersVoice'),
//     mount(): void
//     {
//       tabSection.setup(this.root, (switcher: TabSwitcher) =>
//       {
//         switcher.applyTabs({
//           tabSelector: '.list-post .item .details',
//           panelSelector: '.tab-panels > .entry',
//           activeClassName: 'is_active',
//           initialIndex: 0,
//           // ① フェード + 高さアニメーション（デフォルト）
//           // heightMode を省略 or:
//           heightMode: 'animate',

//           // ② 高さだけ「パッ」と即切り替え（フェードは残る）
//           // heightMode: 'instant',

//           // ③ 全パネルの「最大高さ」に固定（はみ出しなし・画面も動かない）
//           // heightMode: 'fixed',
//         });
//       });
//     }
//   },
//   setup(root: HTMLElement | null, bind: (switcher: TabSwitcher) => void): void
//   {
//     if (!root) return;

//     const switcher = new TabSwitcher(root);
//     bind(switcher);
//   }
// };

// document.addEventListener('DOMContentLoaded', () =>
// {
//   tabSection.mShopping.mount();
//   tabSection.mCustomerVoice.mount();
// });

// const ModalGallery = new ModalDisplay(gSiteBody, document.getElementById('asideHistory'));
// const SlideShow = new SlideDisplay(document.getElementById('slideShow'));


// const gFilteringList = {
//   mount(): void
//   {
//     const filtering_lists = Array.from(
//       document.querySelectorAll<HTMLElement>('[data-filtering-list][data-filter-group]')
//     );

//     if (filtering_lists.length === 0) return;

//     filtering_lists.forEach((filtering_list) =>
//     {
//       const filter_group = filtering_list.dataset.filterGroup;
//       if (!filter_group) return;

//       const filtering_target = document.querySelector<HTMLElement>(
//         `[data-filtering-target][data-filter-group="${filter_group}"]`
//       );

//       if (!filtering_target) return;

//       const list_items = Array.from(
//         filtering_list.querySelectorAll<HTMLElement>(':scope > .item[data-filter]')
//       );

//       const target_items = Array.from(
//         filtering_target.querySelectorAll<HTMLElement>(':scope > .item')
//       );

//       if (list_items.length === 0 || target_items.length === 0) return;

//       const set_visible = (elem: HTMLElement, is_visible: boolean): void =>
//       {
//         elem.hidden = !is_visible;
//       };

//       const set_current = (current_item: HTMLElement): void =>
//       {
//         list_items.forEach((list_item) =>
//         {
//           list_item.classList.remove('current');
//         });

//         current_item.classList.add('current');
//       };

//       const apply_filter = (filter: string): void =>
//       {
//         if (filter === 'all')
//         {
//           target_items.forEach((target_item) =>
//           {
//             set_visible(target_item, true);
//           });
//           return;
//         }

//         target_items.forEach((target_item) =>
//         {
//           const should_show = target_item.classList.contains(filter);
//           set_visible(target_item, should_show);
//         });
//       };

//       const apply_first_filter = (): void =>
//       {
//         const first_item = filtering_list.querySelector<HTMLElement>(
//           ':scope > .item[data-filter]'
//         );

//         const first_filter = first_item?.dataset.filter;

//         if (!first_item || !first_filter) return;

//         set_current(first_item);
//         apply_filter(first_filter);
//       };

//       apply_first_filter();

//       filtering_list.addEventListener('click', (event) =>
//       {
//         const target = event.target as HTMLElement | null;
//         if (!target) return;

//         const item = target.closest<HTMLElement>('.item[data-filter]');
//         if (!item || !filtering_list.contains(item)) return;

//         const filter = item.dataset.filter;
//         if (!filter) return;

//         set_current(item);
//         apply_filter(filter);
//       });
//     });
//   }
// };

// document.addEventListener('DOMContentLoaded', () =>
// {
//   gFilteringList.mount();
// });

// const modalWindow = {
//   mDelightful: {
//     root: document.getElementById('primaryDelightfulDiscovery'),
//     mount(): void
//     {
//       modalWindow.setup(this.root, (modal: ModalDisplay) =>
//       {
//         modal.runProgram();
//       });
//     }
//   },
//   mLifeService: {
//     root: document.getElementById('primaryLifeService'),
//     mount(): void
//     {
//       modalWindow.setup(this.root, (modal: ModalDisplay) =>
//       {
//         modal.runProgram();
//       });
//     }
//   },
//   mShopping: {
//     root: document.getElementById('primaryArchiveShopping'),
//     mount(): void
//     {
//       modalWindow.setup(this.root, (modal: ModalDisplay) =>
//       {
//         modal.runProgram();
//       });
//     }
//   },
//   setup(root: HTMLElement | null, bind: (modal: ModalDisplay) => void): void
//   {
//     if (!root) return;

//     const modal = new ModalDisplay(gSiteBody, root);
//     bind(modal);
//   }
// };

// const gModal = new ModalDisplay(gSiteBody, document.getElementById('primaryDelightfulDiscovery'));

//////////////////////////////////////////////////
/// AREA: イベント、メソッドの実行
//////////////////////////////////////////////////
// window.addEventListener('load', () =>
window.addEventListener('DOMContentLoaded', () =>
{
  // gModal.runProgram();
  // modalWindow.mDelightful.mount();
  // modalWindow.mLifeService.mount();
  // modalWindow.mShopping.mount();
  gLazyController.loadGraphics();
  if (gHeaderNavi.clickToToggleDisplay)
  {
    gHeaderNavi.clickToToggleDisplay();
  }
  if (gHeaderNavi.clickToCloseDisplay)
  {
    gHeaderNavi.clickToCloseDisplay();
  }

  // gSideNavi.scrollFixed();
  gBackScrollBtn.toPageTop();
  gBackScrollBtn.onAnimation();
  gScrollFadeIn.fromLeft.onAnimation();
  gScrollFadeIn.fromBottom.onAnimation();
  gScrollFadeIn.slideDoor.onAnimation();
  gCopyright.dispYear();

  // frontHeroView.scrollAnimation();
  // SlideShow.startAutoSlide();
});

window.addEventListener('scroll', () =>
{
  if (!gScrollFlag)
  {
    window.requestAnimationFrame(() =>
    {
      // gSideNavi.scrollFixed();
      gBackScrollBtn.onAnimation();
      // frontHeroView.scrollAnimation();
      gScrollFadeIn.fromLeft.onAnimation();
      gScrollFadeIn.fromBottom.onAnimation();
      gScrollFadeIn.slideDoor.onAnimation();

      gScrollFlag = false;
    });
    gScrollFlag = true;
  }
});

window.addEventListener('resize', () =>
{
  if (!gResizeFlag)
  {
    window.requestAnimationFrame(() =>
    {
      // gSideNavi.scrollFixed();
      gBackScrollBtn.onAnimation();
      // frontHeroView.scrollAnimation();
      gScrollFadeIn.fromLeft.onAnimation();
      gScrollFadeIn.fromBottom.onAnimation();
      gScrollFadeIn.slideDoor.onAnimation();

      gScrollFlag = false;
    });
    gResizeFlag = true;
  }
});

// const gHeroViewFront = document.getElementById('areaPrimaryHeroView');
// const movie = gHeroViewFront?.querySelector<HTMLVideoElement>('.movie');

// let is_animated = false;

// const handle_movie_ready = (): void =>
// {
//   if (is_animated) return;
//   is_animated = true;

//   gScrollFadeIn.slideDoor.onAnimation();
// };

// movie?.addEventListener('loadeddata', handle_movie_ready);
// movie?.addEventListener('canplay', handle_movie_ready);


//////////////////////////////////////////////////
/// AREA: END
//////////////////////////////////////////////////
